import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import api from '../utils/api';
import '../style.css';
import ApexCharts from 'apexcharts';
import CircularProgress from '@mui/material/CircularProgress';
import { Stack, Typography, Chip, Box } from '@mui/material';
import InfoButtonWithTooltip from './Tooltips';

const BHFunctionChart = ({range, selectedRegions, setSelectedRegions, selectedDistricts, setSelectedDistricts, monthYear}) => {
    const [loadingRegion, setLoadingRegion] = useState(true);
    const [loadingDistrict, setLoadingDistrict] = useState(false);

    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                id:'region-chart',
                type: 'bar',
                height: 350,
                width: '100%',
                stacked: true,
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const regionIndex = config.dataPointIndex;
                        const region = config.w.config.xaxis.categories[regionIndex];
                        setSelectedRegions(prev => {
                            if (prev.includes(region)) {
                                return prev.filter(r => r !== region);
                            } else {
                                return [...prev, region];
                            }
                        });
                    },
                    xAxisLabelClick: (event, chartContext, config) => {
                        const regionIndex = config.labelIndex;
                        const region = config.config.xaxis.categories[regionIndex];
                        setSelectedRegions(prev => {
                            if (prev.includes(region)) {
                                return prev.filter(r => r !== region);
                            } else {
                                return [...prev, region];
                            }
                        });
                    }
                }
            },
            states: {
                normal: { filter: { type: 'lighten', value: 0 } },
                hover: { filter: { type: 'lighten', value: 0 } },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: { type: 'none', value: 0 }
                    // filter: {
                    //     // type: 'light'
                    // }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '12px',
                                fontWeight: 900
                            }
                        }
                    }
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: undefined
            },
            subtitle: {
                text: undefined
            },
            xaxis: {
                categories: [],
                labels: {
                    formatter: (val) => val
                }
            },
            yaxis: {
                title: {
                    text: undefined
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => val
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40
            }
        }
    });

    const [districtChartData, setDistrictChartData] = useState({
        series: [],
        options: {
            chart: {
                id:'region-chart',
                type: 'bar',
                height: 350,
                width: '100%',
                stacked: true,
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const districtIndex = config.dataPointIndex;
                        const district = config.w.config.xaxis.categories[districtIndex];
                        setSelectedDistricts(prev => {
                            if (prev.includes(district)) {
                                return prev.filter(r => r !== district);
                            } else {
                                return [...prev, district];
                            }
                        });
                    },
                    xAxisLabelClick: (event, chartContext, config) => {
                        const districtIndex = config.labelIndex;
                        const district = config.config.xaxis.categories[districtIndex];
                        setSelectedDistricts(prev => {
                            if (prev.includes(district)) {
                                return prev.filter(r => r !== district);
                            } else {
                                return [...prev, district];
                            }
                        });
                    }
                }
            },
            states: {
                normal: { filter: { type: 'lighten', value: 0 } },
                hover: { filter: { type: 'lighten', value: 0 } },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: { type: 'none', value: 0 }
                    // filter: {
                    //     // type: 'light'
                    // }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    }
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: undefined
            },
            subtitle: {
                text: undefined
            },
            xaxis: {
                categories: [],
                labels: {
                    formatter: (val) => val
                }
            },
            yaxis: {
                title: {
                    text: undefined
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => val
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40
            }
        }
    });

     useEffect(() => {
        // console.log('selected Regions:', selectedRegions, 'selected Districts:', selectedDistricts);
        let districtChartEl = document.querySelector("#chart-district");
        let regionChartEl = document.querySelector("#chart-region");
        districtChartEl?.classList.toggle('active', selectedRegions.length > 0);

     },[selectedRegions, selectedDistricts]);

    useEffect(() => {
        if (range[0] != null) {
            setLoadingRegion(true);
            const controller = new AbortController();
            let start_date = new Date(range[0]).toISOString().slice(0, 10);
            let end_date = new Date(range[1]).toISOString().slice(0, 10);
            const monthsParam = monthYear.join(','); 
            api.get('region-borehole-functional/',{
                params: {
                    start: start_date,
                    end: end_date,
                    months : monthsParam
            },
                signal: controller.signal
            })
            .then((res) => {
                const data = JSON.parse(res.data).map((item, index) => ({
                    ...item,
                }));
                // console.log(data[0]);
                const regions = data.map(d => d.region);
                const yesData = data.map(d => d.yes_count);
                const noData = data.map(d => d.no_count);

                setChartData(prev => ({
                    series: [
                        { name: 'Functional', data: yesData },
                        { name: 'Non-Functional', data: noData }
                    ],
                    options: {
                        ...prev.options,
                        colors: ['#00B746', '#FF4560'],
                        xaxis: {
                            ...prev.options.xaxis,
                            categories: regions
                        }
                    }
                }));
            })
            .catch((err) => {
                console.error('Failed to fetch reports:', err);
            })
            .finally(() => setLoadingRegion(false));
            return () => {
                controller.abort();
            };
        }
    }, [monthYear]);

    useEffect(() => {
        
        if (range[0] != null) {
            setLoadingDistrict(true);
            const controller = new AbortController();
            let start_date = new Date(range[0]).toISOString().slice(0, 10);
            let end_date = new Date(range[1]).toISOString().slice(0, 10);
            const monthsParam = monthYear.join(','); 
            api.get('district-borehole-functional/',{
            params: {
                start: start_date,
                end: end_date,
                months : monthsParam
            },
            signal: controller.signal
            })
            .then((res) => {
                
                const data = JSON.parse(res.data).map((item, index) => ({
                    ...item,
                }));
                const filteredData = selectedRegions.length > 0
                    ? data.filter(d => selectedRegions.includes(d.region))
                    : data; // show all if no region selected

                // console.log(filteredData, selectedRegions);
                
                const regions = filteredData.map(d => d.region);
                const districts = filteredData.map(d => d.district);
                const yesData = filteredData.map(d => d.yes_count);
                const noData = filteredData.map(d => d.no_count);

                setDistrictChartData(prev => ({
                    series: [
                        { name: 'Functional', data: yesData },
                        { name: 'Non-Functional', data: noData }
                    ],
                    options: {
                        ...prev.options,
                        colors: ['#00B746', '#FF4560'],
                        xaxis: {
                            ...prev.options.xaxis,
                            categories: districts
                        }
                    }
                }));
            })
            .catch((err) => {
                console.error('Failed to fetch reports:', err);
            })
            .finally(() => setLoadingDistrict(false));
            return () => {
                controller.abort();
            };
        }
    }, [monthYear, selectedRegions]);

    return (
        <>
            <div id="wrap" style={{minHeight:390, maxHeight:390}}>
                {loadingRegion ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <div id="chart-region">
                        <Box sx={{ mb: 0, paddingLeft:'5px' }}>
                            <Typography variant="subtitle1" sx={{ fontSize: 14 }}>
                                Boreholes Functionality by Region <InfoButtonWithTooltip title={'Select Region by click on the bar or region name.'}/>
                            </Typography>
                            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>
                            {(selectedRegions.length ? selectedRegions : ['All regions']).map((r) => (
                                <Chip
                                key={r}
                                size="small"
                                label={r}
                                color={selectedRegions.length ? 'primary' : 'default'}
                                variant={selectedRegions.length ? 'filled' : 'outlined'}
                                onDelete={
                                    selectedRegions.length
                                    ? () => setSelectedRegions((prev) => prev.filter((x) => x !== r))
                                    : undefined
                                }
                                />
                            ))}
                            {selectedRegions.length > 0 && (
                                <Chip
                                size="small"
                                label="Clear"
                                variant="outlined"
                                onClick={() => {
                                    setSelectedRegions([]);
                                    setSelectedDistricts([]);
                                }}
                                />
                            )}
                            </Stack>
                        </Box>

                        <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={310} />
                    </div>
                )}
                {loadingDistrict ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <div id="chart-district">
                        <Box sx={{ mb: 0, paddingLeft:'5px' }}>
                            <Typography variant="subtitle1" sx={{ fontSize: 14 }}>
                                Boreholes Functionality by District <InfoButtonWithTooltip title={'Select District by click on the bar or region name.'}/>
                            </Typography>
                            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>
                            {(selectedDistricts.length ? selectedDistricts : ['All District']).map((r) => (
                                <Chip
                                key={r}
                                size="small"
                                label={r}
                                color={selectedDistricts.length ? 'primary' : 'default'}
                                variant={selectedDistricts.length ? 'filled' : 'outlined'}
                                onDelete={
                                    selectedDistricts.length
                                    ? () => setSelectedDistricts((prev) => prev.filter((x) => x !== r))
                                    : undefined
                                }
                                />
                            ))}
                            {selectedDistricts.length > 0 && (
                                <Chip
                                size="small"
                                label="Clear"
                                variant="outlined"
                                onClick={() => {
                                    setSelectedDistricts([]);
                                }}
                                />
                            )}
                            </Stack>
                        </Box>
                        <ReactApexChart options={districtChartData.options} series={districtChartData.series} type="bar" height={310} />
                    </div>
                )}
            </div>
        </>
    );
};

export default BHFunctionChart;